<template>
    <div class="offline-activity-session">
        <!-- 预热期 未报名 -->
        <div v-if="isPreheatPeriod && !userDetail.hasRegistered && !isFull" class="session-card">
            <!-- 如果用户未获得优先资格，则显示分享邀请好友按钮 -->
            <div class="card-content" v-if="!userDetail.isUserInPriorityGroup">
                <!-- 优先报名模块 -->
                <div class="priority-module">
                    <div class="priority-wrapper">
                        <div class="priority-countdown-bg">
                            <div class="priority-countdown-text">{{ countdownText }}</div>
                            <div class="priority-tag-text">優先報名</div>
                        </div>
                    </div>
                </div>

                <!-- 邀请说明文字 -->
                <div class="invite-desc">成功邀請1位好友參與投資展<br />即可優先報名策略會</div>

                <!-- 邀请按钮 -->
                <div class="action-btn">
                    <div class="btn-wrapper">
                        <img src="../images/btn-bg.svg" class="btn-bg" alt="" />
                        <a class="btn-text" @click="handleInviteFriend">邀請好友</a>
                    </div>
                </div>
            </div>
            <!-- 如果用户已获得优先资格，则显示可优先报名信息 -->
            <div class="card-content" v-else>
                <div class="priority-module">
                    <div class="priority-wrapper-congrate">
                        <!-- 优先报名标签 -->
                        <p class="priority-tag-text">恭喜你，獲得</p>
                        <img class="congrate-img" src="../images/congrate.png" />
                        <p class="priority-tag-text">快報名你感興趣的場次啦！</p>
                    </div>
                </div>
                <!-- 邀请按钮 -->
                <div class="action-btn register-btn priority-register-btn" @click="handleRegister">
                    <div class="btn-wrapper">
                        <img src="../images/btn-bg.svg" class="btn-bg" alt="" />
                        <a class="btn-text">立即報名</a>
                    </div>
                </div>
            </div>
            <div class="top-tip priority-top-tip">每場前50名出席可得專屬周邊</div>
        </div>

        <!-- 正式报名期 未报名 -->
        <div v-if="!isPreheatPeriod && !userDetail.hasRegistered && !isFull" class="session-card">
            <!-- 卡片内容 -->
            <div class="card-content">
                <!-- 未选择场次提示 -->
                <!-- <div class="unselected-tip">未選擇場次</div> -->
                <div class="selected-info">
                    <div class="selected-desc">策略會場次</div>
                    <div class="selected-time">暫未選擇</div>
                </div>

                <!-- 立即报名按钮 -->
                <div class="action-btn register-btn" @click="handleRegister">
                    <div class="btn-wrapper">
                        <img src="../images/btn-bg.svg" class="btn-bg" alt="" />
                        <div class="btn-text">立即報名</div>
                    </div>
                </div>
            </div>
            <div class="top-tip">每場前50名出席可得專屬周邊</div>
        </div>

        <!-- 已選擇場次 -->
        <div v-if="userDetail.hasRegistered && !isFull && canCancel" class="session-card">
            <!-- 卡片内容 -->
            <div class="card-content">
                <!-- 顶部提示文字 -->

                <!-- 已选择场次信息 -->
                <div class="selected-info">
                    <div class="selected-desc">你已選擇策略會場次</div>
                    <div class="selected-time">{{ formatSessionTime(userDetail.session_id) }}</div>
                </div>

                <!-- 取消报名按钮 -->
                <div class="cancel-btn" @click="handleCancelConfirm">
                    <div class="cancel-btn-wrapper">
                        <div class="cancel-btn-text">取消報名</div>
                    </div>
                </div>
            </div>
            <div class="top-tip">每場前50名出席可得專屬周邊</div>
        </div>

        <!-- 已選擇場次(不可取消) -->
        <div v-if="userDetail.hasRegistered && !isFull && !canCancel" class="session-card">
            <!-- 背景图片 -->
            <!-- <img src="../images/bg-card.png" class="card-bg" alt="" /> -->

            <!-- 卡片内容 -->
            <div class="card-content">
                <!-- 已选择场次信息 -->
                <div class="selected-info">
                    <div class="selected-desc">你已選擇策略會場次</div>
                    <div class="selected-time">{{ formatSessionTime(userDetail.session_id) }}</div>
                </div>
                <!-- 核销状态展示 -->
                <div
                    v-if="sessionCheckStatus"
                    class="session-check-status"
                    :class="['session-check-status-' + sessionCheckStatus.status]"
                >
                    {{ sessionCheckStatus.text }}
                </div>
            </div>
            <div class="top-tip">每場前50名出席可得專屬周邊</div>
        </div>

        <!-- 名額已滿 -->
        <div v-if="isFull" class="session-card full-card">
            <!-- 名额已满内容 -->
            <div class="full-content">
                <img src="../images/bg-full.png" class="full-bg" alt="" />

                <div class="full-inner">
                    <!-- 说明文字 -->
                    <div class="full-desc">
                        策略會名額暫時已滿,但你仍可<br />參加工作坊場次或在現場以候補<br />名額參與策略會
                    </div>

                    <!-- 查看工作坊按钮 -->
                    <div class="workshop-btn" @click="handleViewWorkshop">
                        <div class="workshop-btn-wrapper">
                            <!-- <img src="../images/btn-bg.svg" class="workshop-btn-bg" alt="" /> -->
                            <div class="workshop-btn-text">查看工作坊</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 场次选择弹窗 -->
        <SessionSelectModal
            :visible="showSessionModal"
            :sessions="sessionList.sessions"
            @close="handleModalClose"
            @confirm="handleSessionConfirm"
        />

        <!-- 取消确认弹窗 -->
        <CancelConfirmModal
            :visible="showCancelModal"
            @close="handleCancelModalClose"
            @confirm="handleCancelModalConfirm"
        />

        <!-- 策略会报名成功弹窗 -->
        <SessionPopUp
            :visible="showSessionPopUp"
            :nickname="variable.data.userNickname"
            :session="variable.data.sessionTimeText"
            @close="handleSessionPopUpClose"
        />
    </div>
</template>

<script >
import { use as fegoUse } from '@fegobull/webapi';
import dayjs from 'dayjs';
import { computed, onMounted, ref } from 'vue-demi';
import { SessionVerifyStatusEnum } from '../../../../common-offline-activity-ticket-check/static/src/script/api';
import API from '../script/api/index';
import CancelConfirmModal from './CancelConfirmModal.vue';
import SessionPopUp from './SessionPopUp.vue';
import SessionSelectModal from './SessionSelectModal.vue';
const __sfc_main = {};
__sfc_main.props = {
  actSign: {
    type: String,
    default: ''
  },
  module: {
    type: String,
    default: 'strategy-session'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    store: {
      variable
    }
  } = require('@futuweb/fego-render');
  const {
    throttle
  } = require('@futuweb/fego-bridge');
  const {
    useToast
  } = fegoUse;
  const toast = useToast();
  const {
    toLogin,
    isLogin
  } = require('./utils');
  const props = __props;
  const emit = __ctx.emit;

  // 用户数据
  const userData = ref({
    uid: window._params.uid
  });

  // 用户报名详情
  const userDetail = ref({
    id: null,
    actSign: '',
    session_id: null,
    uid: 0,
    status: null,
    verify_time: null,
    create_time: null,
    update_time: null,
    hasRegistered: false,
    isUserInPriorityGroup: false // 当前用户是否满足优先人群（需要登录）
  });

  // 场次列表
  const sessionList = ref({
    sessions: [],
    total: 0,
    isInPriorityPeriod: false,
    isPriorityEnabled: false,
    priorityStartTime: '',
    priorityEndTime: ''
  });

  // 倒计时文字
  const countdownText = ref('還有X日X分結束');

  // 场次选择弹窗显示状态
  const showSessionModal = ref(false);

  // 取消确认弹窗显示状态
  const showCancelModal = ref(false);

  // 策略会报名成功弹窗显示状态
  const showSessionPopUp = ref(false);

  // 是否是预热期（从场次列表接口返回的字段判断）
  const isPreheatPeriod = computed(() => {
    // 使用场次列表接口返回的 isInPriorityPeriod 字段来判断是否在优先级期间
    // 这样未登录状态也可以知道是否为预热阶段
    return sessionList.value?.isInPriorityPeriod || false;
  });

  // 所有策略会是否有剩余名额可报名，且在可报名时间内
  const hasSessionRemain = computed(() => {
    const now = Math.floor(Date.now() / 1000);
    return sessionList.value.sessions.some(session => {
      // 检查是否有剩余名额
      if (Number(session.remainingCount) <= 0) {
        return false;
      }

      // 检查是否在报名时间范围内
      const registrationStartTime = toTimestamp(session.registrationStartTime);
      const registrationEndTime = toTimestamp(session.registrationEndTime);

      // 如果设置了报名开始时间，检查是否已开始
      if (registrationStartTime && now < registrationStartTime) {
        return false;
      }

      // 如果设置了报名结束时间，检查是否未结束
      if (registrationEndTime && now > registrationEndTime) {
        return false;
      }
      return true;
    });
  });

  // 名额是否已满
  const isFull = computed(() => {
    // 如果用户已报名，返回 false
    if (userDetail.value.hasRegistered) {
      return false;
    }

    // 如果没有场次列表，返回 false
    if (sessionList.value.sessions.length === 0) {
      return false;
    }

    // 检查是否所有策略会场次的剩余名额都为0
    return !hasSessionRemain.value;
  });
  const sessionCheckStatus = computed(() => {
    const detail = userDetail.value;
    if (!detail.hasRegistered) {
      return null;
    }
    const verifyStatus = detail.verifyStatus;
    if (verifyStatus === SessionVerifyStatusEnum.PARTICIPATED_VERIFIED) {
      return {
        status: 'done',
        text: ''
      };
    }
    if (verifyStatus === SessionVerifyStatusEnum.PARTICIPATED_WAITING_VERIFIED) {
      return {
        status: 'disabled',
        text: '待核驗'
      };
    }
    if (verifyStatus === SessionVerifyStatusEnum.PARTICIPATED_NOT_VERIFIED) {
      return {
        status: 'disabled',
        text: '待核驗'
      };
    }
    if (verifyStatus === SessionVerifyStatusEnum.PARTICIPATED_ENDED_VERIFIED) {
      return {
        status: 'disabled',
        text: '已過期'
      };
    }
    return null;
  });
  const handleInviteFriend = () => {
    if (!isLogin) {
      toLogin();
      return;
    }
    emit('share_expo_page');
    console.log('邀請好友');
  };
  const handleSessionPopUpClose = () => {
    showSessionPopUp.value = false;
  };

  // 将时间转换为时间戳（秒）
  const toTimestamp = time => {
    if (!time) {
      return null;
    }
    // 如果已经是时间戳（数字类型），直接返回
    if (typeof time === 'number') {
      return time;
    }
    // 如果是字符串，使用 dayjs 解析
    if (typeof time === 'string') {
      return dayjs(time).unix();
    }
    return null;
  };

  // 是否可以取消报名
  const canCancel = computed(() => {
    // 如果用户未报名，返回 false
    if (!userDetail.value.hasRegistered) {
      return false;
    }

    // 如果没有报名的场次 ID，返回 false
    if (!userDetail.value.session_id) {
      return false;
    }

    // 从场次列表中找到用户报名的场次
    const currentSession = sessionList.value.sessions.find(s => s.sessionId === userDetail.value.session_id);

    // 如果找不到对应场次，返回 false
    if (!currentSession) {
      return false;
    }

    // 如果场次没有设置取消截止时间，可以随时取消
    const cancelDeadline = toTimestamp(currentSession.cancelDeadline);
    if (!cancelDeadline) {
      return true;
    }

    // 判断当前时间是否在取消截止时间之前
    const now = Math.floor(Date.now() / 1000);
    return now < cancelDeadline;
  });

  // 更新倒计时
  const updateCountdown = () => {
    // 使用场次列表接口返回的优先级结束时间
    if (!sessionList.value?.priorityEndTime) {
      return;
    }
    const endTimestamp = toTimestamp(sessionList.value.priorityEndTime);
    if (!endTimestamp) {
      return;
    }
    const now = Math.floor(Date.now() / 1000);
    const diff = endTimestamp - now;
    if (diff <= 0) {
      countdownText.value = '已結束';
      return;
    }
    const days = Math.floor(diff / 86400);
    const hours = Math.floor(diff % 86400 / 3600);
    const minutes = Math.floor(diff % 3600 / 60);
    countdownText.value = `還有${days}日${hours}時${minutes}分結束`;
  };

  // 格式化场次时间
  const formatSessionTime = sessionId => {
    const session = sessionList.value.sessions.find(s => Number(s.sessionId) === Number(sessionId));
    if (!session || !session.sessionTime) {
      return '未报名';
    }

    // 如果 sessionTime 是时间戳（数字），格式化为日期
    if (typeof session.sessionTime === 'number') {
      const date = dayjs.unix(session.sessionTime);
      const timeOfDay = date.hour() < 12 ? '上午' : '下午';
      return `${date.format('D/M')} ${timeOfDay}`;
    }

    // 如果 sessionTime 是日期字符串，解析并格式化
    if (typeof session.sessionTime === 'string') {
      // 尝试解析为日期
      const date = dayjs(session.sessionTime);
      if (date.isValid()) {
        const timeOfDay = date.hour() < 12 ? '上午' : '下午';
        return `${date.format('D/M')} ${timeOfDay}`;
      }
      // 如果解析失败，直接返回原字符串
      return session.sessionTime;
    }
    return '';
  };

  // 初始化数据
  const init = async () => {
    try {
      if (!props.actSign) {
        console.error('actSign 未配置');
        return;
      }

      // 如果已登录，并行请求获取用户详情和场次列表
      if (isLogin) {
        const [detailRes, listRes] = await Promise.all([API.getSessionDetail({
          actSign: props.actSign,
          module: props.module
        }), API.getSessionList({
          actSign: props.actSign,
          module: props.module
        })]);
        userDetail.value = detailRes;
        sessionList.value = listRes;
      } else {
        // 未登录时只获取场次列表
        const listRes = await API.getSessionList({
          actSign: props.actSign,
          module: props.module
        });
        sessionList.value = listRes;
      }

      // 设置fego变量
      console.log('userDetail.value------->', userDetail.value);
      variable.data.sessionTimeText = formatSessionTime(userDetail.value.session_id); // 当前选择的策略会场次时间
      console.log('variable.data.sessionTimeText------->', formatSessionTime(userDetail.value.session_id));
      variable.data.hasSessionTicket = userDetail.value.hasRegistered; // 用户是否已报名策略会
      variable.data.hasSessionRemain = hasSessionRemain.value; // 所有的策略会是否有剩余名额可报名
      variable.data.firstSessionRemain = sessionList.value.sessions[0].remainingCount; // 第一场策略会的剩余名额

      // 如果是预热期，启动倒计时
      if (isPreheatPeriod.value) {
        updateCountdown();
        // 每分钟更新一次倒计时
        setInterval(updateCountdown, 60000);
      }
    } catch (error) {
      console.error('加載失敗', error);
      toast.error('加載失敗');
    }
  };

  // 处理立即报名
  const handleRegister = throttle(async () => {
    if (!userData.value.uid) {
      toLogin();
      toast.error('請先登錄');
      return;
    }

    // 显示场次选择弹窗
    showSessionModal.value = true;
  }, 1000);

  // 处理弹窗关闭
  const handleModalClose = () => {
    showSessionModal.value = false;
  };

  // 处理场次选择确认
  const handleSessionConfirm = async session => {
    try {
      const res = await API.joinSession({
        actSign: props.actSign,
        module: props.module,
        sessionId: session.sessionId
      });
      if (res.success) {
        toast.success(res.message || '報名成功');
        // 关闭弹窗
        showSessionModal.value = false;
        // 显示策略会报名成功弹窗
        showSessionPopUp.value = true;
        // 重新加载数据
        await init();
        emit('sign_session_success');
      } else {
        toast.error(res.message || '報名失敗');
      }
    } catch (error) {
      console.error('報名失敗', error);
      toast.error('報名失敗');
    }
  };

  // 处理取消报名确认
  const handleCancelConfirm = throttle(async () => {
    // 显示取消确认弹窗
    showCancelModal.value = true;
  }, 1000);

  // 处理取消弹窗关闭
  const handleCancelModalClose = () => {
    showCancelModal.value = false;
  };

  // 执行取消报名
  const handleCancelModalConfirm = async () => {
    try {
      const res = await API.cancelSession({
        actSign: props.actSign,
        module: props.module,
        sessionId: userDetail.value.session_id
      });
      if (res.success) {
        toast.success(res.message || '取消成功');
        // 关闭弹窗
        showCancelModal.value = false;
        // 重新加载数据
        await init();
      } else {
        toast.error(res.message || '取消失敗');
      }
    } catch (error) {
      console.error('取消失敗', error);
      toast.error('取消失敗');
    }
  };

  // 处理查看工作坊
  const handleViewWorkshop = throttle(() => {
    // 定位至工作坊tab
    emit('switch_workshop');
    console.log('定位至工作坊tab');
  }, 1000);
  onMounted(() => {
    init();
  });
  return {
    variable,
    userDetail,
    sessionList,
    countdownText,
    showSessionModal,
    showCancelModal,
    showSessionPopUp,
    isPreheatPeriod,
    isFull,
    sessionCheckStatus,
    handleInviteFriend,
    handleSessionPopUpClose,
    canCancel,
    formatSessionTime,
    handleRegister,
    handleModalClose,
    handleSessionConfirm,
    handleCancelConfirm,
    handleCancelModalClose,
    handleCancelModalConfirm,
    handleViewWorkshop
  };
};
__sfc_main.components = Object.assign({
  SessionSelectModal,
  CancelConfirmModal,
  SessionPopUp
}, __sfc_main.components);
export default __sfc_main;
</script>

<style scoped lang="less">
.offline-activity-session {
    // 卡片容器
    .session-card {
        // layout_EYGXWF, layout_5FR5V9, layout_25Q34I, layout_Z896J0
        display: flex;
        flex-direction: column;
        gap: 0.1rem;
        width: 6.71rem;
        position: relative;
        width: 6.709rem;
        height: 2.59rem;
        background-image: url('../images/bg-card.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        background-position: center center;

        // 背景图片
        .card-bg {
            // layout_BQ6340 转换为背景定位
            position: absolute;
            top: 0;
            left: 0;
            width: 6.71rem;
            height: auto;
            border-radius: 0 0 0.12rem 0.12rem;
            z-index: 0;
        }

        // 卡片内容
        .card-content {
            position: relative;
            z-index: 1;
            padding: 0.4rem 0.25rem;

            // 顶部提示文字
            // layout_EPZ4UA, style_Z5P9K0, fill_08LDAP
            .top-tip {
                font-family: FZLanTingHei-M-GBK, sans-serif;
                font-weight: 400;
                font-size: 0.24rem;
                line-height: 1.3em;
                letter-spacing: 0.04em;
                color: #535353;
                width: 3.3rem;
                height: 0.51rem;
            }

            // 优先报名模块
            // layout_MO8O9P
            .priority-module {
                // margin-top: 0.38rem;
                .priority-wrapper-congrate {
                    position: relative;
                    width: 3.5rem;
                    height: 1.25rem;
                    .priority-tag-text {
                        color: #fff;
                        font-size: 0.28rem;
                    }
                    .congrate-img {
                        width: 3.08rem;
                        height: 0.6063rem;
                    }
                }
                .priority-wrapper {
                    // layout_URWUOC
                    position: relative;
                    width: 3.5rem;
                    height: 0.4165rem;

                    // 倒计时背景
                    .priority-countdown-bg {
                        width: 3.55rem;
                        height: 0.4165rem;
                        background-image: url('../images/count-down-bg.png');
                        background-size: 100% 100%;
                        background-repeat: no-repeat;
                        background-position: center center;
                    }
                    // 倒计时文字
                    // layout_QU73C8, style_RMPR4S, fill_MHF5GH
                    .priority-countdown-text {
                        position: absolute;
                        left: 1.3rem;
                        top: 0.0621rem;
                        // width: 1.62rem;
                        height: 0.2812rem;
                        font-family: FZLanTingHeiS-DB1-BIG5, sans-serif;
                        font-weight: 400;
                        font-size: 0.2128rem;
                        line-height: 1.326em;
                        color: #9e9e9e;
                    }

                    // 优先报名标签背景
                    // layout_GZG80L, fill_LJY27O
                    .priority-tag-bg {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 1.0228rem;
                        height: 0.4142rem;
                    }

                    // 优先报名标签文字
                    // layout_W1XLJN, style_RMPR4S, fill_DHTACO
                    .priority-tag-text {
                        position: absolute;
                        left: 0.2rem;
                        top: 0.0621rem;
                        width: 0.86rem;
                        height: 0.2812rem;
                        font-family: FZLanTingHeiS-DB1-BIG5, sans-serif;
                        font-weight: 400;
                        font-size: 0.2128rem;
                        line-height: 1.326em;
                        color: #ffffff;
                    }
                }
            }

            // 邀请说明文字
            // layout_Y9TPHR, style_NSU29L, fill_DHTACO
            .invite-desc {
                margin-top: 0.1rem;
                font-family: FZLanTingHei-R-GBK, sans-serif;
                font-weight: 400;
                font-size: 0.28rem;
                line-height: 1.3571em;
                color: #ffffff;
                width: 3.54rem;
                height: 0.7631rem;
            }

            // 未选择场次提示
            // layout_LPEQCW, style_NSU29L, fill_DHTACO
            .unselected-tip {
                margin-top: 0.78rem;
                margin-left: 0.4rem;
                font-family: FZLanTingHei-R-GBK, sans-serif;
                font-weight: 400;
                font-size: 0.28rem;
                line-height: 1.3571em;
                color: #ffffff;
                width: 1.61rem;
                height: 0.32rem;
            }

            // 已选择场次信息
            // layout_G0ZWRO
            .selected-info {
                margin-top: 0.2rem;
                margin-left: 0.1rem;
                width: 3.54rem;
                height: 1rem;

                // 描述文字
                // layout_6ETWCW, style_NSU29L, fill_DHTACO
                .selected-desc {
                    font-family: FZLanTingHei-R-GBK, sans-serif;
                    font-weight: 400;
                    font-size: 0.28rem;
                    line-height: 1.3571em;
                    color: #ffffff;
                    width: 3.54rem;
                    height: 0.38rem;
                    margin-left: 0.09rem;
                }

                // 时间文字
                // layout_7VLQG6, style_RPTBMA, fill_7TNZ60
                .selected-time {
                    margin-top: 0.06rem;
                    font-family: FZLanTingHeiS-DB1-BIG5, sans-serif;
                    font-weight: 400;
                    font-size: 0.43rem;
                    line-height: 1em;
                    background: linear-gradient(90deg, #fffcf7 0%, #ffe0b3 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                    width: 3.54rem;
                    // height: 0.7631rem;
                    margin-left: 0.09rem;
                }
            }

            // 操作按钮（邀请好友、立即报名）
            // layout_CA532Z, layout_PMQ5J3
            .action-btn {
                position: absolute;
                right: 0.25rem;
                bottom: 0.64rem;
                &.priority-register-btn {
                    top: 0.8rem;
                }
                &.register-btn {
                    bottom: 0.64rem;
                }

                .btn-wrapper {
                    // layout_KX6CIQ
                    position: relative;
                    width: 1.6024rem;
                    height: 0.687rem;

                    // 按钮背景
                    // layout_KX6CIQ, fill_ZIEEG5
                    .btn-bg {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 1.6024rem;
                        height: 0.687rem;
                        border-radius: 0.9002rem;
                    }

                    // 按钮文字
                    // layout_EUCL1T, style_U08Z1D, fill_DHTACO
                    .btn-text {
                        position: absolute;
                        left: 0.2524rem;
                        top: 0.17rem;
                        width: 1.12rem;
                        height: 0.3664rem;
                        font-family: FZLanTingHeiS-DB1-GBK, sans-serif;
                        font-weight: 400;
                        font-size: 0.28rem;
                        line-height: 1.1445em;
                        text-align: center;
                        color: #ffffff;
                    }
                }
            }

            // 取消报名按钮
            // layout_1ZYGYN
            .cancel-btn {
                position: absolute;
                right: 0.25rem;
                bottom: 0.88rem;
                cursor: pointer;

                .cancel-btn-wrapper {
                    // layout_DVL31U
                    position: relative;
                    width: 1.12rem;
                    height: 0.32rem;
                    opacity: 0.8;

                    // 取消报名文字
                    // layout_DVL31U, style_U08Z1D, fill_DHTACO
                    .cancel-btn-text {
                        font-family: FZLanTingHeiS-DB1-GBK, sans-serif;
                        font-weight: 400;
                        font-size: 0.28rem;
                        line-height: 1.1445em;
                        text-align: center;
                        color: #ffffff;
                    }
                }
            }
        }
        .priority-top-tip {
            margin-top: -0.05rem;
        }
        .top-tip {
            font-family: FZLanTingHei-M-GBK, sans-serif;
            font-weight: 400;
            font-size: 0.24rem;
            line-height: 1.3em;
            letter-spacing: 0.04em;
            color: #535353;
            // width: 3.3rem;
            height: 0.51rem;
            margin-left: 0.35rem;
        }
    }

    // 名额已满卡片
    .full-card {
        // layout_GFGSB1
        width: 6.7089rem;
        height: 2.63rem;
        background-image: none;

        .full-content {
            // layout_PLNRR3, fill_FREBBK, stroke_PJUUW1
            display: flex;
            flex-direction: row;
            align-items: center;
            gap: 0.41rem;
            padding: 0.4rem 0.24rem;
            width: 6.7089rem;
            height: 1.95rem;
            border: 1px solid #dddddd;
            border-radius: 0.12rem;
            position: relative;
            overflow: hidden;

            .full-bg {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: fit;
                z-index: 0;
            }

            .full-inner {
                position: relative;
                z-index: 1;
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 0.41rem;
                width: 100%;

                // 说明文字
                // layout_9ZOR86, style_NSU29L, fill_DHTACO
                .full-desc {
                    font-family: FZLanTingHei-R-GBK, sans-serif;
                    font-weight: 400;
                    font-size: 0.28rem;
                    line-height: 1.3571em;
                    color: #ffffff;
                    flex: 1;
                }

                // 查看工作坊按钮
                // layout_RQG0CP
                .workshop-btn {
                    width: 1.81rem;
                    height: 0.6rem;
                    cursor: pointer;

                    .workshop-btn-wrapper {
                        // layout_6O4YVU
                        position: relative;
                        width: 1.81rem;
                        height: 0.6rem;
                        background-color: #ff6900;
                        border-radius: 0.9002rem;
                        // 按钮背景
                        // layout_6O4YVU, fill_ZIEEG5
                        .workshop-btn-bg {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 1.81rem;
                            height: 0.6rem;
                            border-radius: 0.9002rem;
                        }

                        // 按钮文字
                        // layout_1MLMIW, style_U08Z1D, fill_DHTACO
                        .workshop-btn-text {
                            position: absolute;
                            left: 0.21rem;
                            top: 0.14rem;
                            width: 1.4rem;
                            height: 0.32rem;
                            font-family: FZLanTingHeiS-DB1-GBK, sans-serif;
                            font-weight: 400;
                            font-size: 0.28rem;
                            line-height: 1.1445em;
                            text-align: center;
                            color: #ffffff;
                        }
                    }
                }
            }
        }
    }
}

.session-check-status {
    position: absolute;
    right: 0.25rem;
    bottom: 0.74rem;
    width: 1.6rem;
    height: 0.6rem;
    &-done {
        background: url(../images//checked-btn.png) no-repeat center center / 100% 100%;
    }
    &-disabled {
        background: #888;
        border-radius: 0.9rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 0.28rem;
        color: #ffffff;
    }
}
</style>
